import { render, staticRenderFns } from "./AnSituation.vue?vue&type=template&id=224f5928&scoped=true&"
import script from "./AnSituation.vue?vue&type=script&lang=js&"
export * from "./AnSituation.vue?vue&type=script&lang=js&"
import style0 from "./AnSituation.vue?vue&type=style&index=0&id=224f5928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224f5928",
  null
  
)

export default component.exports